/**
 * Re-entrancy gate shared by both mirror directions.
 *
 * Both stores notify listeners synchronously, so a boolean gate is sufficient
 * to prevent a mirror-originated write in one store from echoing back through
 * the other store's listener. The gate makes echoes structurally impossible
 * rather than relying on field-diff convergence.
 */
let mirrorInProgress = false

export function isMirrorWriteInProgress(): boolean {
  return mirrorInProgress
}

export function runMirrorWrite(fn: () => void): void {
  mirrorInProgress = true
  try {
    fn()
  } finally {
    mirrorInProgress = false
  }
}
